import Errors from "@/stores/modules/alert/ErrorsModule";
import Warnings from "@/stores/modules/alert/WarningsModule";
import Info from "@/stores/modules/alert/InfoModule";
export default {
  state: {
    val: {
      message: "",
      result: {}
    }
  },
  getters: {
    getVal: state => state.val
  },
  actions: {
    setVal({ commit }, args) {
      commit("SUCCES_MSG", args);
    },
    resetVal({ commit }) {
      commit("SUCCES_MSG", {
        message: "",
        result: {}
      });
    }
  },
  mutations: {
    SUCCES_MSG: (state, payload) => {
      state.val = payload;
    }
  },
  namespaced: true,
  modules: {
    Errors,
    Warnings,
    Info
  }
};
